import React from 'react';
import { string, shape, arrayOf, func } from 'prop-types';

export default function TabFilter({ filter, selectedItems, toggleFilters, resetFilterGroup }) {
    const onClick = (e, filters, value) => {
        toggleFilters(e, filters, value, true, resetFilterGroup(filters.code, true));
    };

    const isIncludedItem = (list, item) => {
        let isIn = false;
        list.forEach(listItem => {
            if (listItem.toUpperCase() === item.toUpperCase()) {
                isIn = true;
            }
        });
        return isIn;
    };

    return (
        <div className="tab-filter-wrapper">
            <div className="tab-filter-dt">
                {/* Button tab styles for tablet and up */}
                <ul>
                    <li className={`tab-filter-item ${selectedItems.length === 0 ? 'active' : ''}`}>
                        <button onClick={() => resetFilterGroup(filter.code)}>
                            All {filter.label}
                        </button>
                    </li>
                    {filter.values.map(value => (
                        <li
                            key={value}
                            className={`tab-filter-item ${isIncludedItem(selectedItems, value) ? 'active' : ''}`}
                        >
                            <button
                                onClick={e => onClick(e, filter, value)}
                                dangerouslySetInnerHTML={{ __html: value }}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

TabFilter.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(string).isRequired
    }).isRequired,
    selectedItems: arrayOf(string).isRequired,
    toggleFilters: func.isRequired,
    resetFilterGroup: func.isRequired
    /* eslint-enable react/no-typos */
};
